import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { ArrowLeft, X } from 'lucide-react'
import { ViewerContainer, BackButton, IframeContainer, ErrorMessage, CloseButton } from './viewer-style'

const DocViewer: React.FC = () => {
  const { docId } = useParams<{ docId: string }>()
  const navigate = useNavigate()
  const [error, setError] = useState(false)

  const docPath = `/docs/${docId}/index.html`

  useEffect(() => {
    const checkDoc = async () => {
      try {
        const response = await fetch(docPath, { method: 'HEAD' })
        if (!response.ok) {
          setError(true)
        }
      } catch (err) {
        setError(true)
      }
    }
    
    checkDoc()
  }, [docPath])

  const handleBack = () => {
    navigate('/panel/docs')
  }

  if (error) {
    return (
      <ViewerContainer>
        <CloseButton onClick={() => navigate('/panel')} title="Voltar ao painel">
          <X size={20} />
        </CloseButton>
        
        <BackButton onClick={handleBack}>
          <ArrowLeft size={20} />
          Voltar
        </BackButton>
        <ErrorMessage>
          ❌ Documentação não encontrada para: {docId}
        </ErrorMessage>
      </ViewerContainer>
    )
  }

  return (
    <ViewerContainer>
      <CloseButton onClick={() => navigate('/panel')} title="Voltar ao painel">
        <X size={20} />
      </CloseButton>
      
      <BackButton onClick={handleBack}>
        <ArrowLeft size={20} />
        Voltar para Documentações
      </BackButton>
      
      <IframeContainer>
        <iframe
          src={docPath}
          title={`Documentação - ${docId}`}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: '8px'
          }}
        />
      </IframeContainer>
    </ViewerContainer>
  )
}

export default DocViewer
